import { createSlice } from "@reduxjs/toolkit"
import {
  changePassword,
  forgotPassword,
  getProfileDetails,
  login,
  otpVerification,
  resendVerifyOtp,
  resetPassword,
  updateBankDetails,
  updateGeneralDetails,
  updateJobApplicationDetails,
  updateProfileDocument,
  verifyAndLogin,
  assetsDeliveryConfirmation,
} from "store/actions/authAction"

const initialState = {
  isLoggedIn: false,
  loading: false,
  isLoading: null,
  userDetails: {},
  userType: localStorage.getItem("userType") || "",
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(login.pending, state => {
        state.isLoading = true
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false
        const { success } = action.payload || {}
        if (success) {
          const { data } = action.payload
          state.userDetails = data
          state.isLoggedIn = true
          state.userType = data.user_type // candidate,
          // state.userType = "candidate" // candidate,

          localStorage.setItem("authUser", JSON.stringify(data))
          localStorage.setItem("isLoggedIn", true)
          localStorage.setItem("userType", data.user_type)
          localStorage.setItem("uuid", data.uuid)
        }
      })
      .addCase(login.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(forgotPassword.pending, state => {
        state.isLoading = true
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(forgotPassword.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(otpVerification.pending, state => {
        state.isLoading = true
      })
      .addCase(otpVerification.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(otpVerification.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(changePassword.pending, state => {
        state.isLoading = true
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(changePassword.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(getProfileDetails.pending, state => {
        state.loading = true
      })
      .addCase(getProfileDetails.fulfilled, (state, action) => {
        state.loading = false
        const { success } = action.payload || {}
        if (success) {
          const { data } = action.payload
          state.userDetails = data
        }
      })
      .addCase(getProfileDetails.rejected, state => {
        state.loading = false
      })

    builder
      .addCase(updateGeneralDetails.pending, state => {
        state.isLoading = true
      })
      .addCase(updateGeneralDetails.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateGeneralDetails.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(updateBankDetails.pending, state => {
        state.isLoading = true
      })
      .addCase(updateBankDetails.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateBankDetails.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(updateJobApplicationDetails.pending, state => {
        state.isLoading = true
      })
      .addCase(updateJobApplicationDetails.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateJobApplicationDetails.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updateProfileDocument.pending, state => {
        state.isLoading = true
      })
      .addCase(updateProfileDocument.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateProfileDocument.rejected, (state, action) => {
        state.isLoading = false
      })
    builder
      .addCase(resetPassword.pending, state => {
        state.isLoading = true
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(verifyAndLogin.pending, state => {
        state.isLoading = true
      })
      .addCase(verifyAndLogin.fulfilled, (state, action) => {
        state.isLoading = false
        const { success } = action.payload || {}
        if (success) {
          const { data } = action.payload
          state.userDetails = data
          state.isLoggedIn = true
          state.userType = data.user_type // candidate,
          // state.userType = "candidate" // candidate,

          localStorage.setItem("authUser", JSON.stringify(data))
          localStorage.setItem("isLoggedIn", true)
          localStorage.setItem("userType", data.user_type)
          localStorage.setItem("uuid", data.uuid)
        }
      })
      .addCase(verifyAndLogin.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(resendVerifyOtp.pending, state => {
        state.isLoading = true
      })
      .addCase(resendVerifyOtp.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(resendVerifyOtp.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(assetsDeliveryConfirmation.pending, state => {
        state.isLoading = true
      })
      .addCase(assetsDeliveryConfirmation.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(assetsDeliveryConfirmation.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default authSlice.reducer
